import React, { useEffect } from 'react';
import '../../logger';
import '../../monitor';
import Render from '@/.one/render';

function Page() {
  useEffect(() => {
    window.iTracker.pageMonitor('index', undefined, true);
  }, []);
  return <Render />;
}

export default Page;
